export default __webpack_public_path__ + "static/ghost_nervous-bfd43cda43c00292693028c68d6e0830.svg";